import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=274fd483&"
import script from "./assistant.vue?vue&type=script&lang=js&"
export * from "./assistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports